import { AppEnvironment, Environment, OptionalApplicationFeature } from 'ngx-esprio-shared';

export const environment: AppEnvironment = {
  production: false,
  environment: Environment.webk,
  apiBaseUrl: 'https://dev.ernaehrungsbegleiter.de/api/v1',
  monitoringApp: 'https://monitoring.dev.ernaehrungsbegleiter.de',
  userApp: 'https://dev.ernaehrungsbegleiter.de',
  useMockServices: false,
  defaultLanguage: 'de',
  disabledAppFeatures: [OptionalApplicationFeature.LanguagePicker],
};
